"use strict";const n=(t,r)=>{if(t.length!==r.length)return!1;for(let e=0;e<t.length;e++)if(t[e]!==r[e])return!1;return!0};export default n;
//# sourceMappingURL=arraysAreEqual.js.map
